enum RoutePath {
  Language = '/language',
  ManageMobi = '/managemobi',
  OpenApp = '/open-app/:platform',
  UpdateRequired = '/update-required',

  Login = '/login',
  LoginWithPassword = '/login/with-password',
  LoginWithCode = '/login/with-code',
  ForgotPassword = '/login/forgot-password',
  ForgotAccessCode = '/login/forgot-access-code',
  ForgotPasswordSuccess = '/login/forgot-password-success',
  LoginWithEmailLink = '/login/with-email-link',

  Event = '/event',
  EventList = '/event/list',
  EventDetail = '/event/events/:eventId',
  EventPeopleDetail = '/event/events/:eventId/people/:idOrEmail',
  EventCheck = '/event/events/:eventId/check/:action',
  EventPeopleSearch = '/event/events/:eventId/people',
  EventKiosk = '/event/events/:eventId/kiosk',

  Session = '/session',
  SessionList = '/session/list/events/:eventId',
  SessionPeopleDetail = '/session/sessions/:sessionId/events/:eventId/people/:idOrEmail',
  SessionCheck = '/session/sessions/:sessionId/events/:eventId/check/:action',
  SessionPeopleSearch = '/session/sessions/:sessionId/events/:eventId/people',
  SessionKiosk = '/session/sessions/:sessionId/events/:eventId/kiosk',

  Kiosk = '/kiosk',
  KioskEvent = '/kiosk/events/:eventId',
  KioskUnlockWithPassword = '/kiosk/unlock-with-password',
  KioskUnlockWithCode = '/kiosk/unlock-with-code',
  KioskEventCheck = '/kiosk/events/:eventId/check',
  KioskEventPeopleSearch = '/kiosk/events/:eventId/people',
  KioskSessionCheck = '/kiosk/events/:eventId/sessions/:sessionId/check',
  KioskSessionPeopleSearch = '/kiosk/events/:eventId/sessions/:sessionId/people',

  Lead = '/lead',
  LeadHome = '/lead/home',
  LeadList = '/lead/list',
  LeadAdd = '/lead/add',
  LeadEdit = '/lead/leads/edit',
  CompanyList = '/lead/company/list',
}

export default RoutePath;
